import { useTranslation } from 'react-i18next';
import SparklesIcon from './SparklesIcon';

/**
 * Splash shown while a hosted workspace's first sync has not landed (and
 * during initial data load): spinner + indeterminate progress bar, NO
 * widgets — wrong numbers must never render. The pages poll the workspaces
 * query while this is up, so it clears itself when the sync completes.
 */
export default function SyncSplash() {
  const { t } = useTranslation();
  return (
    <div className="flex items-center justify-center py-24">
      <div className="max-w-sm w-full text-center">
        <div className="mx-auto mb-5 flex items-center justify-center w-12 h-12 rounded-2xl bg-primary-50 border border-primary-100">
          <svg className="w-6 h-6 text-primary-600 animate-spin" fill="none" viewBox="0 0 24 24">
            <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4" />
            <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4z" />
          </svg>
        </div>
        <h2 className="text-lg font-semibold text-gray-900 mb-1">{t('analytics.sync.title')}</h2>
        <p className="text-sm text-gray-400 mb-6">{t('analytics.sync.subtitle')}</p>

        {/* Indeterminate progress bar */}
        <div className="h-1.5 w-full bg-primary-100 rounded-full overflow-hidden">
          <div className="h-full w-1/3 bg-primary-600 rounded-full animate-[syncslide_1.4s_ease-in-out_infinite]" />
        </div>

        <style>{`
          @keyframes syncslide {
            0% { transform: translateX(-100%); }
            50% { transform: translateX(150%); }
            100% { transform: translateX(300%); }
          }
        `}</style>

        <div className="mt-6 flex items-center justify-center gap-1.5 text-xs text-gray-300">
          <SparklesIcon className="w-3.5 h-3.5" />
          {t('analytics.sync.hint')}
        </div>
      </div>
    </div>
  );
}
